import { FluidIconKey } from '@lmig/fluid-core';

import Australia from '../../assets/svg/flags/au.svg';
import Belgium from '../../assets/svg/flags/be.svg';
import Brazil from '../../assets/svg/flags/br.svg';
import Canada from '../../assets/svg/flags/ca.svg';
import Chile from '../../assets/svg/flags/cl.svg';
import China from '../../assets/svg/flags/cn.svg';
import Colombia from '../../assets/svg/flags/co.svg';
import Germany from '../../assets/svg/flags/de.svg';
import Ecuador from '../../assets/svg/flags/ec.svg';
import Spain from '../../assets/svg/flags/es.svg';
import France from '../../assets/svg/flags/fr.svg';
import UnitedKingdom from '../../assets/svg/flags/gb.svg';
import HongKong from '../../assets/svg/flags/hk.svg';
import Ireland from '../../assets/svg/flags/ie.svg';
import India from '../../assets/svg/flags/in.svg';
import Italy from '../../assets/svg/flags/it.svg';
import Japan from '../../assets/svg/flags/jp.svg';
import Mexico from '../../assets/svg/flags/mx.svg';
import Malaysia from '../../assets/svg/flags/my.svg';
import Peru from '../../assets/svg/flags/pe.svg';
import Portugal from '../../assets/svg/flags/pt.svg';
import Singapore from '../../assets/svg/flags/sg.svg';
import Thailand from '../../assets/svg/flags/th.svg';
import UnitedStates from '../../assets/svg/flags/us.svg';
import Vietnam from '../../assets/svg/flags/vn.svg';
import YouTube from '../../assets/svg/icons/contributed/youtube.svg';
import Angular from '../../assets/svg/icons/legacy/angular.svg';
import CaretDown from '../../assets/svg/icons/legacy/caret-down.svg';
import CaretLeft from '../../assets/svg/icons/legacy/caret-left.svg';
import CaretRight from '../../assets/svg/icons/legacy/caret-right.svg';
import CaretUp from '../../assets/svg/icons/legacy/caret-up.svg';
import Loader from '../../assets/svg/icons/legacy/circle-notch.svg';
import CircleO from '../../assets/svg/icons/legacy/circle-o.svg';
import Code from '../../assets/svg/icons/legacy/code.svg';
import EmailSolid from '../../assets/svg/icons/legacy/envelope-solid.svg';
import Visible from '../../assets/svg/icons/legacy/eye.svg';
import Hidden from '../../assets/svg/icons/legacy/eye-slash.svg';
import Gavel from '../../assets/svg/icons/legacy/gavel.svg';
import Globe from '../../assets/svg/icons/legacy/globe.svg';
import Negotiated from '../../assets/svg/icons/legacy/handshake.svg';
import Javascript from '../../assets/svg/icons/legacy/js.svg';
import ListOl from '../../assets/svg/icons/legacy/list-ol.svg';
import ListUl from '../../assets/svg/icons/legacy/list-ul.svg';
import Map from '../../assets/svg/icons/legacy/map.svg';
import React from '../../assets/svg/icons/legacy/react.svg';
import Shield from '../../assets/svg/icons/legacy/shield.svg';
import Back from '../../assets/svg/icons/legacy/step-backward.svg';
import Forward from '../../assets/svg/icons/legacy/step-forward.svg';
import Svelte from '../../assets/svg/icons/legacy/svelte.svg';
import Updated from '../../assets/svg/icons/legacy/updated.svg';
import Vue from '../../assets/svg/icons/legacy/vuejs.svg';
import Wrench from '../../assets/svg/icons/legacy/wrench.svg';
import AiSpark from '../../assets/svg/icons/lm/ai-spark.svg';
import SortDown from '../../assets/svg/icons/lm/arrow-down.svg';
import ArrowDown from '../../assets/svg/icons/lm/arrow-down.svg';
import ArrowLeft from '../../assets/svg/icons/lm/arrow-left.svg';
import ArrowRight from '../../assets/svg/icons/lm/arrow-right.svg';
import SortUp from '../../assets/svg/icons/lm/arrow-up.svg';
import ArrowUp from '../../assets/svg/icons/lm/arrow-up.svg';
import Attachment from '../../assets/svg/icons/lm/attachment.svg';
import Bars from '../../assets/svg/icons/lm/bars.svg';
import Bullhorn from '../../assets/svg/icons/lm/bullhorn.svg';
import Calculator from '../../assets/svg/icons/lm/calculator.svg';
import Calendar from '../../assets/svg/icons/lm/calendar.svg';
import Camera from '../../assets/svg/icons/lm/camera.svg';
import Check from '../../assets/svg/icons/lm/check.svg';
import CheckCircle from '../../assets/svg/icons/lm/check-circle-o.svg';
import Success from '../../assets/svg/icons/lm/check-circle-o.svg';
import CheckCircleO from '../../assets/svg/icons/lm/check-circle-o.svg';
import ChevronDown from '../../assets/svg/icons/lm/chevron-down.svg';
import ChevronLeft from '../../assets/svg/icons/lm/chevron-left.svg';
import ChevronRight from '../../assets/svg/icons/lm/chevron-right.svg';
import ChevronUp from '../../assets/svg/icons/lm/chevron-up.svg';
import CollapseLeft from '../../assets/svg/icons/lm/collapse-left.svg';
import CollapseRight from '../../assets/svg/icons/lm/collapse-right.svg';
import CommentQuestion from '../../assets/svg/icons/lm/comment-question.svg';
import Comments from '../../assets/svg/icons/lm/comments.svg';
import Copy from '../../assets/svg/icons/lm/copy.svg';
import Delete from '../../assets/svg/icons/lm/delete.svg';
import Dismiss from '../../assets/svg/icons/lm/dismiss.svg';
import Uncheck from '../../assets/svg/icons/lm/dismiss-circle.svg';
import Document from '../../assets/svg/icons/lm/document.svg';
import DocumentMulti from '../../assets/svg/icons/lm/document-multi.svg';
import Dollar from '../../assets/svg/icons/lm/dollar.svg';
import Download from '../../assets/svg/icons/lm/download.svg';
import Edit from '../../assets/svg/icons/lm/edit.svg';
import Pencil from '../../assets/svg/icons/lm/edit.svg';
import EllipsisVertical from '../../assets/svg/icons/lm/ellipsis-v.svg';
import Email from '../../assets/svg/icons/lm/email.svg';
import Error from '../../assets/svg/icons/lm/exclamation-circle.svg';
import Warning from '../../assets/svg/icons/lm/exclamation-triangle.svg';
import ExpandLeft from '../../assets/svg/icons/lm/expand-left.svg';
import ExpandRight from '../../assets/svg/icons/lm/expand-right.svg';
import ExternalLink from '../../assets/svg/icons/lm/external-link.svg';
import FaceHappy from '../../assets/svg/icons/lm/face-happy.svg';
import FaceNeutral from '../../assets/svg/icons/lm/face-neutral.svg';
import FaceSad from '../../assets/svg/icons/lm/face-sad.svg';
import FaceVeryHappy from '../../assets/svg/icons/lm/face-very-happy.svg';
import FaceVerySad from '../../assets/svg/icons/lm/face-very-sad.svg';
import File from '../../assets/svg/icons/lm/file.svg';
import FileAlt from '../../assets/svg/icons/lm/file.svg';
import Filter from '../../assets/svg/icons/lm/filter_lm.svg';
import Flag from '../../assets/svg/icons/lm/flag.svg';
import Folder from '../../assets/svg/icons/lm/folder.svg';
import FolderOpen from '../../assets/svg/icons/lm/folder-open.svg';
import Form from '../../assets/svg/icons/lm/form.svg';
import History from '../../assets/svg/icons/lm/history.svg';
import Image from '../../assets/svg/icons/lm/image.svg';
import Info from '../../assets/svg/icons/lm/info-circle.svg';
import Lightbulb from '../../assets/svg/icons/lm/lightbulb.svg';
import Link from '../../assets/svg/icons/lm/link.svg';
import Location from '../../assets/svg/icons/lm/location.svg';
import Locked from '../../assets/svg/icons/lm/lock.svg';
import Unlocked from '../../assets/svg/icons/lm/lock-open.svg';
import MemoCircle from '../../assets/svg/icons/lm/memo-circle-info.svg';
import Minus from '../../assets/svg/icons/lm/minus.svg';
import Notes from '../../assets/svg/icons/lm/notes.svg';
import Plus from '../../assets/svg/icons/lm/plus.svg';
import Print from '../../assets/svg/icons/lm/print.svg';
import Question from '../../assets/svg/icons/lm/question-circle.svg';
import Refresh from '../../assets/svg/icons/lm/refresh.svg';
import Restore from '../../assets/svg/icons/lm/restore.svg';
import Save from '../../assets/svg/icons/lm/save.svg';
import Search from '../../assets/svg/icons/lm/search.svg';
import Settings from '../../assets/svg/icons/lm/settings.svg';
import Share from '../../assets/svg/icons/lm/share.svg';
import Star from '../../assets/svg/icons/lm/star-branded.svg';
import StarFilled from '../../assets/svg/icons/lm/star-filled.svg';
import StarOutline from '../../assets/svg/icons/lm/star-outline.svg';
import Support from '../../assets/svg/icons/lm/support.svg';
import Undo from '../../assets/svg/icons/lm/undo.svg';
import Unlink from '../../assets/svg/icons/lm/unlink.svg';
import Upload from '../../assets/svg/icons/lm/upload.svg';
import User from '../../assets/svg/icons/lm/user.svg';
import UserAccount from '../../assets/svg/icons/lm/user-account.svg';
import AiBadge from '../../assets/svg/icons/standalone/ai-badge.svg';
import FLUID from '../../assets/svg/icons/standalone/fluid-logo.svg';
import Slack from '../../assets/svg/icons/standalone/slack.svg';
import Teams from '../../assets/svg/icons/standalone/teams.svg';

export const LMIcons = {
  [FluidIconKey.AI_SPARK]: { icon: AiSpark, scale: 0 },
  [FluidIconKey.ARROW_DOWN]: { icon: ArrowDown, scale: 5 },
  [FluidIconKey.ARROW_LEFT]: { icon: ArrowLeft, scale: 5 },
  [FluidIconKey.ARROW_RIGHT]: { icon: ArrowRight, scale: 5 },
  [FluidIconKey.ARROW_UP]: { icon: ArrowUp, scale: 5 },
  [FluidIconKey.ATTACHMENT]: { icon: Attachment, scale: 0 },
  [FluidIconKey.BACK]: { icon: Back, scale: 20 },
  [FluidIconKey.BARS]: { icon: Bars, scale: 15 },
  [FluidIconKey.BULLHORN]: { icon: Bullhorn, scale: 0 },
  [FluidIconKey.CALCULATOR]: { icon: Calculator, scale: 0 },
  [FluidIconKey.CALENDAR]: { icon: Calendar, scale: 0 },
  [FluidIconKey.CAMERA]: { icon: Camera, scale: 0 },
  [FluidIconKey.CARET_DOWN]: { icon: CaretDown, scale: 40 },
  [FluidIconKey.CARET_LEFT]: { icon: CaretLeft, scale: 40 },
  [FluidIconKey.CARET_RIGHT]: { icon: CaretRight, scale: 40 },
  [FluidIconKey.CARET_UP]: { icon: CaretUp, scale: 40 },
  [FluidIconKey.CHECK]: { icon: Check, scale: 0 },
  [FluidIconKey.CHECK_CIRCLE]: { icon: CheckCircle, scale: 0 },
  [FluidIconKey.CHECK_CIRCLE_O]: { icon: CheckCircleO, scale: 0 },
  [FluidIconKey.CHEVRON_DOWN]: { icon: ChevronDown, scale: 5 },
  [FluidIconKey.CHEVRON_LEFT]: { icon: ChevronLeft, scale: 5 },
  [FluidIconKey.CHEVRON_RIGHT]: { icon: ChevronRight, scale: 5 },
  [FluidIconKey.CHEVRON_UP]: { icon: ChevronUp, scale: 5 },
  [FluidIconKey.CIRCLE_O]: { icon: CircleO, scale: 0 },
  [FluidIconKey.CODE]: { icon: Code, scale: 5 },
  [FluidIconKey.COLLAPSE]: { icon: ChevronUp, scale: 5 },
  [FluidIconKey.COLLAPSE_LEFT]: { icon: CollapseLeft, scale: 0 },
  [FluidIconKey.COLLAPSE_RIGHT]: { icon: CollapseRight, scale: 0 },
  [FluidIconKey.COMMENT_QUESTION]: { icon: CommentQuestion, scale: 0 },
  [FluidIconKey.COMMENTS]: { icon: Comments, scale: 0 },
  [FluidIconKey.COPY]: { icon: Copy, scale: 0 },
  [FluidIconKey.DELETE]: { icon: Delete, scale: 0 },
  [FluidIconKey.DISMISS]: { icon: Dismiss, scale: 10 },
  [FluidIconKey.DOCUMENT]: { icon: Document, scale: 0 },
  [FluidIconKey.DOCUMENT_MULTI]: { icon: DocumentMulti, scale: 0 },
  [FluidIconKey.DOLLAR]: { icon: Dollar, scale: 0 },
  [FluidIconKey.DOWNLOAD]: { icon: Download, scale: 0 },
  [FluidIconKey.EDIT]: { icon: Edit, scale: 0 },
  [FluidIconKey.ELLIPSIS_VERTICAL]: { icon: EllipsisVertical, scale: 0 },
  [FluidIconKey.EMAIL]: { icon: Email, scale: 0 },
  [FluidIconKey.EMAIL_SOLID]: { icon: EmailSolid, scale: 10 },
  [FluidIconKey.ERROR]: { icon: Error, scale: 0 },
  [FluidIconKey.EXPAND]: { icon: ChevronDown, scale: 5 },
  [FluidIconKey.EXPAND_LEFT]: { icon: ExpandLeft, scale: 0 },
  [FluidIconKey.EXPAND_RIGHT]: { icon: ExpandRight, scale: 0 },
  [FluidIconKey.EXTERNAL_LINK]: { icon: ExternalLink, scale: 0 },
  [FluidIconKey.FACE_HAPPY]: { icon: FaceHappy, scale: 0 },
  [FluidIconKey.FACE_NEUTRAL]: { icon: FaceNeutral, scale: 0 },
  [FluidIconKey.FACE_SAD]: { icon: FaceSad, scale: 0 },
  [FluidIconKey.FACE_VERY_HAPPY]: { icon: FaceVeryHappy, scale: 0 },
  [FluidIconKey.FACE_VERY_SAD]: { icon: FaceVerySad, scale: 0 },
  [FluidIconKey.FILE]: { icon: File, scale: 0 },
  [FluidIconKey.FILE_ALT]: { icon: FileAlt, scale: 0 },
  [FluidIconKey.FILTER]: { icon: Filter, scale: 0 },
  [FluidIconKey.FLAG]: { icon: Flag, scale: 5 },
  [FluidIconKey.FOLDER]: { icon: Folder, scale: 0 },
  [FluidIconKey.FOLDER_OPEN]: { icon: FolderOpen, scale: 0 },
  [FluidIconKey.FORM]: { icon: Form, scale: 0 },
  [FluidIconKey.FORWARD]: { icon: Forward, scale: 20 },
  [FluidIconKey.GAVEL]: { icon: Gavel, scale: 15 },
  [FluidIconKey.GLOBE]: { icon: Globe, scale: 0 },
  [FluidIconKey.HIDDEN]: { icon: Hidden, scale: 0 },
  [FluidIconKey.HISTORY]: { icon: History, scale: 0 },
  [FluidIconKey.IMAGE]: { icon: Image, scale: 0 },
  [FluidIconKey.INFO]: { icon: Info, scale: 0 },
  [FluidIconKey.LIGHTBULB]: { icon: Lightbulb, scale: 0 },
  [FluidIconKey.LINK]: { icon: Link, scale: 0 },
  [FluidIconKey.LIST_OL]: { icon: ListOl, scale: 15 },
  [FluidIconKey.LIST_UL]: { icon: ListUl, scale: 15 },
  [FluidIconKey.LOADER]: { icon: Loader, scale: 0 },
  [FluidIconKey.LOCATION]: { icon: Location, scale: 0 },
  [FluidIconKey.LOCKED]: { icon: Locked, scale: 0 },
  [FluidIconKey.MAP]: { icon: Map, scale: 0 },
  [FluidIconKey.MEMO_CIRCLE_INFO]: { icon: MemoCircle, scale: 0 },
  [FluidIconKey.MINUS]: { icon: Minus, scale: 5 },
  [FluidIconKey.NEGOTIATED]: { icon: Negotiated, scale: 0 },
  [FluidIconKey.NOTES]: { icon: Notes, scale: 0 },
  [FluidIconKey.PENCIL]: { icon: Pencil, scale: 0 },
  [FluidIconKey.PLUS]: { icon: Plus, scale: 5 },
  [FluidIconKey.PRINT]: { icon: Print, scale: 0 },
  [FluidIconKey.QUESTION]: { icon: Question, scale: 0 },
  [FluidIconKey.REFRESH]: { icon: Refresh, scale: 0 },
  [FluidIconKey.RESTORE]: { icon: Restore, scale: 0 },
  [FluidIconKey.SAVE]: { icon: Save, scale: 0 },
  [FluidIconKey.SEARCH]: { icon: Search, scale: 0 },
  [FluidIconKey.SETTINGS]: { icon: Settings, scale: 0 },
  [FluidIconKey.SHARE]: { icon: Share, scale: 0 },
  [FluidIconKey.SHIELD]: { icon: Shield, scale: 0 },
  [FluidIconKey.SORT_DOWN]: { icon: SortDown, scale: 5 },
  [FluidIconKey.SORT_UP]: { icon: SortUp, scale: 5 },
  [FluidIconKey.STAR]: { icon: Star, scale: 0 },
  [FluidIconKey.SUCCESS]: { icon: Success, scale: 0 },
  [FluidIconKey.SUPPORT]: { icon: Support, scale: 0 },
  [FluidIconKey.UNCHECK]: { icon: Uncheck, scale: 0 },
  [FluidIconKey.UNDO]: { icon: Undo, scale: 0 },
  [FluidIconKey.UNLINK]: { icon: Unlink, scale: 0 },
  [FluidIconKey.UNLOCKED]: { icon: Unlocked, scale: 0 },
  [FluidIconKey.UPDATED]: { icon: Updated, scale: -25 },
  [FluidIconKey.UPLOAD]: { icon: Upload, scale: 0 },
  [FluidIconKey.USER]: { icon: User, scale: 0 },
  [FluidIconKey.USER_ACCOUNT]: { icon: UserAccount, scale: 0 },
  [FluidIconKey.VISIBLE]: { icon: Visible, scale: 0 },
  [FluidIconKey.WARNING]: { icon: Warning, scale: 0 },
  [FluidIconKey.WRENCH]: { icon: Wrench, scale: 10 },
  [FluidIconKey.STAR_OUTLINE]: { icon: StarOutline, scale: 0 },
  [FluidIconKey.STAR_FILLED]: { icon: StarFilled, scale: 0 },

  // Frameworks / Platforms
  [FluidIconKey.ANGULAR]: { icon: Angular, scale: 0 },
  [FluidIconKey.JAVASCRIPT]: { icon: Javascript, scale: 0 },
  [FluidIconKey.REACT]: { icon: React, scale: 0 },
  [FluidIconKey.SVELTE]: { icon: Svelte, scale: 0 },
  [FluidIconKey.VUE]: { icon: Vue, scale: 0 },
  [FluidIconKey.YOUTUBE]: { icon: YouTube, scale: 0 },

  // Standalone
  [FluidIconKey.AI_BADGE]: { icon: AiBadge, scale: 0, standalone: true },
  [FluidIconKey.FLUID]: { icon: FLUID, scale: 0, standalone: true },
  [FluidIconKey.SLACK]: { icon: Slack, scale: 0, standalone: true },
  [FluidIconKey.TEAMS]: { icon: Teams, scale: 0, standalone: true },

  // Flags
  [FluidIconKey.AUSTRALIA]: { icon: Australia, scale: 5 },
  [FluidIconKey.BELGIUM]: { icon: Belgium, scale: 5 },
  [FluidIconKey.BRAZIL]: { icon: Brazil, scale: 5 },
  [FluidIconKey.CANADA]: { icon: Canada, scale: 5 },
  [FluidIconKey.CHILE]: { icon: Chile, scale: 5 },
  [FluidIconKey.CHINA]: { icon: China, scale: 5 },
  [FluidIconKey.COLOMBIA]: { icon: Colombia, scale: 5 },
  [FluidIconKey.ECUADOR]: { icon: Ecuador, scale: 5 },
  [FluidIconKey.FRANCE]: { icon: France, scale: 5 },
  [FluidIconKey.GERMANY]: { icon: Germany, scale: 5 },
  [FluidIconKey.HONG_KONG]: { icon: HongKong, scale: 5 },
  [FluidIconKey.INDIA]: { icon: India, scale: 5 },
  [FluidIconKey.IRELAND]: { icon: Ireland, scale: 5 },
  [FluidIconKey.ITALY]: { icon: Italy, scale: 5 },
  [FluidIconKey.JAPAN]: { icon: Japan, scale: 5 },
  [FluidIconKey.MALAYSIA]: { icon: Malaysia, scale: 5 },
  [FluidIconKey.MEXICO]: { icon: Mexico, scale: 5 },
  [FluidIconKey.PERU]: { icon: Peru, scale: 5 },
  [FluidIconKey.PORTUGAL]: { icon: Portugal, scale: 5 },
  [FluidIconKey.SINGAPORE]: { icon: Singapore, scale: 5 },
  [FluidIconKey.SPAIN]: { icon: Spain, scale: 5 },
  [FluidIconKey.THAILAND]: { icon: Thailand, scale: 5 },
  [FluidIconKey.UNITED_KINGDOM]: { icon: UnitedKingdom, scale: 5 },
  [FluidIconKey.USA]: { icon: UnitedStates, scale: 5 },
  [FluidIconKey.VIETNAM]: { icon: Vietnam, scale: 5 },
};
